<template>
  <div>
    <div>
      <router-link :to="{ name: 'distribution_centers' }" style="
          font-size: 14px;
          text-decoration: none;
          line-height: 30px;
          color: #98c14b;
          display: flex;
        ">
        <p>
          <a-icon type="double-left" />
        </p>
        <p>Go Back</p>
      </router-link>

      <h3 style="font-size: 28px; line-height: 45px">
        {{ distroCentre.name }}'s Details
      </h3>
      <a-row style="margin-bottom: 2em;">
        <a-col :span="24">
          <div style="background: #fff; padding: 20px">
            <p style="font-weight: bolder">Distribution Centre Details</p>
            <a-row :gutter="42" type="flex">
              <a-col :span="6">
                <h4 :style="{ fontSize: '18px', color: '#333' }">
                  Centre's Name:
                </h4>
                <p style="font-weight: medium; color: #5f6060">
                  {{ distroCentre.name ? distroCentre.name : "N/A" }}
                </p>
              </a-col>
              <a-col :span="6">
                <h4 :style="{ fontSize: '18px', color: '#333' }">
                  Centre's Address:
                </h4>
                <p style="font-weight: medium; color: #5f6060">
                  {{ distroCentre.address ? distroCentre.address : "N/A" }}
                </p>
              </a-col>
            </a-row>
          </div>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="24">
          <div class="card-container">
            <a-tabs type="card">
              <a-tab-pane key="1">
                <span slot="tab">
                  Inventory
                </span>
                <div class="requestActions">
                  <a-button @click="handleInventoryExport" style="
                      width: 159px;
                      height: 38px;
                      margin-right: 10px;
                      border-raduis: 5px;
                      background: #418a49;
                      color: #fff;
                      float: right;
                    " icon="export">
                    Export
                  </a-button>
                </div>
                <AllDistroInventoriesTable :inventories="inventories" />
              </a-tab-pane>
              <a-tab-pane key="2">
                <span slot="tab">
                  Replenishment
                </span>
                <div class="requestActions">
                  <a-button @click="handleOrdersExport" style="
                      width: 159px;
                      height: 38px;
                      margin-right: 10px;
                      border-raduis: 5px;
                      background: #418a49;
                      color: #fff;
                      float: right;
                    " icon="export">
                    Export
                  </a-button>
                </div>
                <AllDistroOrdersTable :orders="orders" />
              </a-tab-pane>
              <a-tab-pane key="3">
                <span slot="tab">
                  Stock Counts
                </span>
                <div class="requestActions">
                  <a-button @click="handleStockCountExport" style="
                      width: 159px;
                      height: 38px;
                      margin-right: 10px;
                      border-raduis: 5px;
                      background: #418a49;
                      color: #fff;
                      float: right;
                    " icon="export">
                    Export
                  </a-button>
                </div>
                <AllDistroStockCounts :counts="stockCounts" />
              </a-tab-pane>
              <a-tab-pane key="4">
                <span slot="tab">
                  Inventory History
                </span>
                <InventoryReport :distributionCenter="distroCentre" />
              </a-tab-pane>
            </a-tabs>
          </div>
        </a-col>
      </a-row>
    </div>
  </div>
</template>

<script>
import XLSX from "xlsx";
import moment from "moment";
import { NotificationMixins } from "@/mixins/NotificationMixins";

export default {
  components: {
    AllDistroInventoriesTable: () =>
      import("@/components/locations/tables/AllDistroInventories"),
    AllDistroOrdersTable: () =>
      import("@/components/locations/tables/AllDistroOrders"),
    AllDistroStockCounts: () =>
      import("@/components/locations/tables/DistroStockCounts"),
    InventoryReport: () =>
      import("@/components/locations/tables/InventoryReports"),
  },
  computed: {
    distroCentre() {
      return this.$store.getters["distroCenter/GetSingleDistro"];
    },
    inventories() {
      return this.$store.getters["distroCenter/GetDistroInventories"];
    },
    orders() {
      return this.$store.getters["distroCenter/GetDistrOrders"];
    },
    stockCounts() {
      return this.$store.getters["distroCenter/GetStockCounts"];
    },
  },
  mixins: [NotificationMixins],
  methods: {
    handleInventoryExport() {
      const dataToExport = [
        [
          "ID",
          "Product Name",
          "Product Category",
          "Product SKU",
          "Purchase Price",
          "Selling Price",
          "Product Balance",
        ],
      ];
      this.inventories.data.forEach((inventory) => {
        dataToExport.push([
          inventory.id,
          inventory.brandName,
          inventory.categoryName,
          inventory.sku,
          inventory.purchasePrice,
          inventory.sellingPrice,
          inventory.balance,
        ]);
      });

      var wb = XLSX.utils.book_new();
      var ws = XLSX.utils.aoa_to_sheet(dataToExport);

      /* Add the worksheet to the workbook */
      XLSX.utils.book_append_sheet(wb, ws, "Sheet 1");

      /* generate file and send to client */
      XLSX.writeFile(
        wb,
        `Export-Distribution-Centres-Inventory-${moment().format(
          "DD-MM-YYYY"
        )}.xlsx`
      );
      this.showSuccessAlert("Data Successfully Exported");
    },
    handleOrdersExport() {
      const dataToExport = [
        [
          "Order ID",
          "Retailer Store",
          "Distribution Centre",
          "Amount",
          "Order status",
          "Ordered Date",
        ],
      ];
      this.orders.data.forEach((order) => {
        dataToExport.push([
          order.id,
          order.destinationLocationName,
          order.sourceLocationName,
          (order.amount = order.total
            ? `Ksh ${order.total.toLocaleString(undefined, {
              minimumFractionDigits: 2,
            })}`
            : "N/A"),
          order.statusLabel,
          (order.orderedAt = moment(order.orderedAt).format("DD-MMM-YYYY")),
        ]);
      });

      var wb = XLSX.utils.book_new();
      var ws = XLSX.utils.aoa_to_sheet(dataToExport);

      /* Add the worksheet to the workbook */
      XLSX.utils.book_append_sheet(wb, ws, "Sheet 1");

      /* generate file and send to client */
      XLSX.writeFile(
        wb,
        `Export-Distribution-Centres-Orders-${moment().format(
          "DD-MM-YYYY"
        )}.xlsx`
      );
      this.showSuccessAlert("Data Successfully Exported");
    },
    handleStockCountExport() {
      const dataToExport = [
        ["Stock ID", "Stock Type", "Quantity", "Created At"],
      ];
      this.stockCounts.data.forEach((stock) => {
        dataToExport.push([
          stock.id,
          stock.typeLabel,
          (stock.quantity = stock.inventoryCountLines.length),
          (stock.createdAt = moment(stock.createdAt).format("DD-MMM-YYYY")),
        ]);
      });

      var wb = XLSX.utils.book_new();
      var ws = XLSX.utils.aoa_to_sheet(dataToExport);

      /* Add the worksheet to the workbook */
      XLSX.utils.book_append_sheet(wb, ws, "Sheet 1");

      /* generate file and send to client */
      XLSX.writeFile(
        wb,
        `Export-Distribution-Centres-StockCounts-${moment().format(
          "DD-MM-YYYY"
        )}.xlsx`
      );
      this.showSuccessAlert("Data Successfully Exported");
    },
  },
  watch: {
    distroCentre: {
      immediate: true,
      handler: function (activeCenter) {
        if (Object.keys(activeCenter).length < 1) {
          // console.log("empty data");
          this.$router.go(-1);
        }
      },
    },
  },
  mounted() {
    this.$store.dispatch("distroCenter/FetchDistroInventories");
    this.$store.dispatch("distroCenter/FetchDistroOrders");
    this.$store.dispatch("distroCenter/FetchStockCounts");
  },
};
</script>

<style scoped>
/* Start Style for Tab  */

.card-container {
  background: none;
  overflow: hidden;
  /* padding: 24px; */
}

.card-container>.ant-tabs-card>.ant-tabs-content {
  height: 120px;
  margin-top: -16px;
}

.card-container>.ant-tabs-card>.ant-tabs-content>.ant-tabs-tabpane {
  background: #fff;
  padding: 16px;
}

.card-container>>>.ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-tab-active {
  height: 40px;
  color: #98c14b;
  background: #e5efe7;
  border-color: #e5efe7;
  border-bottom: 1px solid #98c14b;
}

.card-container>>>.ant-tabs-tab {
  height: 40px;
  margin: 0;
  width: 217px;
  margin-right: 2px;
  padding: 0 16px;
  line-height: 38px;
  background: #fafafa;
  border: 1px solid #e8e8e8;
}

.card-container>>>.ant-tabs-tab:hover {
  color: #98c14b;
  /* background: #e5efe7; */
}

.card-container>>>.ant-badge-count {
  z-index: auto;
  min-width: 20px;
  height: 20px;
  padding: 0 6px;
  color: #fff;
  font-weight: normal;
  font-size: 12px;
  line-height: 20px;
  white-space: nowrap;
  text-align: center;
  background: #98c14b;
  border-radius: 10px;
  box-shadow: 0 0 0 1px #fff;
}

.card-container>.ant-tabs-card>.ant-tabs-bar {
  border-color: #fff;
}

.card-container>>>.ant-tabs-card>.ant-tabs-bar {
  border: none;
}

.card-container>>>.ant-tabs-card>.ant-tabs-bar .ant-tabs-tab {
  height: 40px;
  color: #111827;
  background: transparent;
  border-radius: 8px;
  max-width: 15%;
  margin-right: 12px;
}


.card-container>>>.ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-tab-active {
  height: 40px;
  color: #fff;
  background: #418a49;
  border-bottom: none;
  border-radius: 8px;
  max-width: 15%;
}
/* End Style for Tab  */
</style>